<template>
  <div class="no-padding">

    <!-- Header Label -->
    <label v-if="editable" class="editable-header" @click="$emit('edit_clicked', 'header', 0)" v-html="header_html"></label>
    <label v-else class="question-label">{{ item.header || item.name }}</label>
    
    <!-- Render Column Headers -->
    <m-row class="mb-2">
      <m-col :lg="first_colspan"> </m-col>
      <m-col 
        v-for="(column, colIndex) in item.columns"
        :key="colIndex"
        :lg="divider_cols"
        class="m-col"
      >
      <div v-if="editable" class="editable-option" @click="edit_column_header_clicked(column, colIndex)">
        {{ column.label }}
      </div>
      <div v-else>{{ column.label }}</div>
        
      </m-col>
      <m-col lg="1" v-if="editable && item.columns.length < 5"><memlist-table-button text="Ny kolumn" @click="addColumn" svg="/assets/svg/plus-square.svg" /></m-col>
    </m-row>


    <!-- Matrix Rows -->
    <div v-for="(row, rowIndex) in item.rows" :key="rowIndex">
      <m-row>
        <!-- Row Label -->
        <m-col :lg="first_colspan">
          <div v-if="editable" class="editable-option" @click="edit_row_header_clicked(row, rowIndex)">
            {{ row }}
          </div>
          <div v-else>{{ row }}</div>
        </m-col>

        <!-- Render Radio Buttons for each column -->
        <m-col class="m-col" v-for="(column, colIndex) in item.columns" :key="colIndex" :lg="divider_cols">
          <label class="custom-radio">
            <input
              type="radio"
              :name="`row-${rowIndex}`"
              :id="`radio-${rowIndex}-${colIndex}`"
              :value="column.label"
              v-model="selected_value[rowIndex]"
              @change="option_selected(rowIndex, column.label)"
            />
            <span class="custom-radio-button"></span>
          </label>
        </m-col>

        <m-col lg="1" v-if="editable && item.columns.length < 5"></m-col>
      </m-row>
    </div>

  </div>
</template>

<script>
export default {
  name: 'QuestionMatrixOption',
  emits: ['edit_clicked', 'selected'],
  props: ['item', 'preselected', 'editable'],
  
  data() {
    return {
      selected_value: [],
      
    };
  },
  computed: {
    header_html() {
      return this.item.header || this.item.name;
    },
    divider_cols() {

      if (this.item.columns.length === 5) {
        return 2;
      }

      return Math.floor( (12 - 4) / this.item.columns.length );
    },
    first_colspan() {
      return this.item.columns.length > 4 ? 2 : (4 - (this.editable ? 1 : 0));
    }
  },
  methods: {
    edit_row_header_clicked(row, index) {
      this.$emit('edit_clicked', 'row_header', index);
    },
    edit_column_header_clicked(column, index) {
      this.$emit('edit_clicked', 'column_header', index);
    },
    addColumn() {
      // Logic for adding a new column dynamically
      this.columns.push(`Column ${this.item.columns.length + 1}`);
    },
    option_selected(rowIndex, value) {
      this.$emit('selected', rowIndex, value);
    }
  }
};
</script>

<style scoped>
.matrix-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.column-label {
  font-weight: bold;
  margin: 0 10px;
  flex: 1;
}

.add-column-btn {
  cursor: pointer;
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.editable-header {
  min-width: 300px;
  min-height: 20px;
  padding: 8px;
}

.editable-header:hover {
  border: 2px solid rgb(50, 201, 50);
}

.row-label {
  font-weight: normal;
  margin-right: 20px; 
}

.custom-radio {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.custom-radio input {
  position: absolute;
  opacity: 0;
}

.custom-radio-button {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid gray;
  background-color: white;
  display: inline-block;
  position: relative;
}

.custom-radio input:checked + .custom-radio-button {
  background-color: #2D9BF0;
  border-color: #2D9BF0;
}

.custom-radio-button::after {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: white;
  opacity: 0;
}

.custom-radio input:checked + .custom-radio-button::after {
  opacity: 1;
}

.m-col {
  display: flex;
  justify-content: center;
  align-items: center;
}
.editable-option {
  min-width: 60px;
  min-height: 20px;
  padding: 2px;
}
.editable-option:hover {
  border: 2px solid rgb(50, 201, 50);
}
</style>
